import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { adminLogOut } from '../../../redux/actions/adminActions'
export class Navbar extends Component {
  handleLogout=()=>{
    this.props.adminLogOut()
  }
  
  componentWillUnmount=()=>{
    this.props.adminLogOut()
  }

  render() {
    return (
      <div className="admin-navbar-container">
        <div className="admin-navbar">
          <img src={require('../../../assets/img/bonanza-logo-aangepast.png')} alt=""/>
          <div className="nav">
            <p><Link to="/admin/dashboard">Dashboard</Link></p>
            <p><Link to="/admin/products">Producten</Link></p>
            <p><Link to="/admin/pakketten">Pakketten</Link></p>
            <p><Link to="/admin/orders">Orders</Link></p>
          </div>
          <div className="settings">
          <button onClick={this.handleLogout} className="small-main-btn">Uitloggen</button>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, {adminLogOut})(Navbar)
